import { render } from "./Fees.vue?vue&type=template&id=49ae884a&scoped=true"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"

import "./Fees.vue?vue&type=style&index=0&id=49ae884a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ae884a"]])

export default __exports__